import React from "react";
import { Header } from "@deere/fuel-react"; // Import Header component from Deere's UI library
import HeaderPopJD from "./HeaderPopJD"; // Import custom HeaderPopJD component
import { Agriculture, AttachMoney, Construction, Home } from "@mui/icons-material"; // Import icons from Material-UI

// Define a functional component named HeaderJOHN
export default function HeaderJOHN() {
  return (
    <Header
      navigationItems={[
        {
          href: "https://www.deere.com/en/",
          label: "Home",
          startIcon: <Home />,
        },
        {
          href: "https://www.deere.com/en/equipment/",
          label: "Equipment",
          startIcon: <Agriculture />,
        },
        {
          href: "https://www.deere.com/en/finance/financing/",
          label: "Finance",
          startIcon: <AttachMoney />,
        },
        {
          href: "https://shop.deere.com/us",
          label: "Parts & Service",
          startIcon: <Construction />,
        },
      ]}
      title="Ops Center &amp; JDLink&trade; | Contact Us"
    >
      {/* Custom pop-up component for the header */}
      {<HeaderPopJD />}
    </Header>
  );
}
